class TicketStamping {
  constructor({
    eticket = '',
    serie = '',
    transaccion = '',
    reservationCode = '',
    estado = '',
    uuid = '',
    urlPdf = '',
    pathXml = '',
    pdfBytes = '',
    xmlBytes = '',
    pathPdf = null,
  }) {
    this.eticket = eticket;
    this.serie = serie;
    this.transaccion = transaccion;
    this.reservationCode = reservationCode;
    this.estado = estado;
    this.uuid = uuid;
    this.urlPdf = urlPdf;
    this.eticket = eticket;
    this.pathXml = pathXml;
    this.pdfBytes = pdfBytes;
    this.xmlBytes = xmlBytes;
    this.pathPdf = pathPdf;
  }
}

export default TicketStamping;